<section id="content" *ngIf="data">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>Create Ticket</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/super/'+AppFrontRoutes.TICKET_LIST">{{lang.supportTicket}}</a>
          </li>
          <li>
            <a [routerLink]="'/super/'+AppFrontRoutes.TICKET_CREATE">{{lang.createTicket}}</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body">
              <div role="tabpanel">

                <div class="tab-content">

                  <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
                    <div *ngFor="let validation of msg">
                      <div class="error-message"
                        *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
                        {{validation.message}}
                      </div>
                    </div>
                  </ng-template>

                  <form [formGroup]="createForm" class="form-validation" (ngSubmit)="createFormSubmit()">

                      <div class="form-group">
                        <label>{{lang.category}}</label>
                        
                        <select class="form-control" formControlName="category" [ngClass]="formErrorClass(createForm.controls.category, createFormSubmitted)">
                          <option *ngFor="let category of categories | keyvalue" [ngValue]="category.value.category_id">{{category.value.description}}</option>
                        </select>

                        <ng-template [ngTemplateOutlet]="ErrorMsg"
                        [ngTemplateOutletContext]="{msg:createFormErrorMsg.category, value:createForm.controls.category, submitted:createFormSubmitted }">
                        </ng-template>


                      </div>

                      <div class="form-group">
                        <label>{{lang.description}}</label>
                        
                        <ckeditor 
                        formControlName="content"
                        [config]="ckeditorOptions"
                        [ngClass]="formErrorClass(createForm.controls.content, createFormSubmitted)"
                        ></ckeditor>

                        <ng-template [ngTemplateOutlet]="ErrorMsg"
                        [ngTemplateOutletContext]="{msg:createFormErrorMsg.content, value:createForm.controls.content, submitted:createFormSubmitted }">
                        </ng-template>

                      </div>
                    
                      <div class="form-group text-center">
                        <button type="submit" class="btn btn-success mb-10">{{lang.createTicket}}</button>
                      </div>

                  </form>
                </div>



              </div>
            </div>
          
          </div>
        </div>
      </div>

    </div>

  </div>
</section>